import { Component, OnInit } from "@angular/core";
import {
  BaseUpdateComponent,
  BaseDataService,
  ModalService,
  QueryParameter,
  NotificationService
} from "yt-ng-framework";
import { AngazovanjeRo } from "./angazovanje-ro";
import { ActivatedRoute } from "@angular/router";
// import { NotificationsService } from "angular2-notifications";
import { Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ModelDataService } from "yt-ng-framework";
import { UgovorRo } from "./ugovor-ro";
import { AngazovanjeRoResenje } from "./angazovanje-ro-resenje";
import { RadnoVreme } from "../radno-vreme/radno-vreme";
import { AngazovanjeRoValidators } from "../_validators/angazovanje-ro-validators";
import { kadblDajBrojZaNoviDokument, kadblDajPodrazumevaniNedeljniFondSatiZaPrcAng } from "src/app/kad.bl/angazovanje-ro.bl";
import { resolve } from "url";
import { async } from "@angular/core/testing";
import { StatusRo } from "../status-ro/status-ro";
// import { ToastrService } from "ngx-toastr";

@Component({
  selector: "yt-angazovanje-ro-update",
  templateUrl: "./angazovanje-ro-update.component.html"
})
export class AngazovanjeRoUpdateComponent extends BaseUpdateComponent<UgovorRo>
  implements OnInit {
  // Ugovor=false;
  // RaskidUgovora=false;
  // AneksUgovora=false;
  AnexDostupan = true;
  RaskidDostupan = true;
  UnosPoslovaDostupan=true;  
  editMode = false;
  // RadnoVremeGenericName="";
  statusRoItems;
  radnoVremeItems;
  angazovanjeRoValidators=new AngazovanjeRoValidators();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modelDataService: ModelDataService,
    protected modalService: ModalService
  ) {
    super(
      activatedRoute,
      baseDataService,
      toastrService,
      translateService
    );
  }

  ngOnInit() {
    super.ngOnInit();

    this.addValidatorToFc(
      "StatusRoID",
      Validators.required,
      "required",
      "ANGAZOVANJERO.STATUSRO.VALIDATION.REQUIRED"
    );

    this.addValidatorToFc(
      "RadnoMestoID",
      Validators.required,
      "required",
      "ANGAZOVANJERO.RADNOMESTO.VALIDATION.REQUIRED"
    );

    this.addValidatorToFc(
      "MestoRadaID",
      Validators.required,
      "required",
      "ANGAZOVANJERO.MESTORADA.VALIDATION.REQUIRED"
    );

    this.addValidatorToFc(
      "PrcAng"
      , Validators.min(1)
      , "min"
      , "ANGAZOVANJERO.PRCANG.VALIDATION.MIN"
    )

    this.addValidatorToFc(
      "BrojPoslodavaca"
      , Validators.min(1)
      , "min"
      , "ANGAZOVANJERO.BROJPOSLODAVACA.VALIDATION.MIN"
    )

    this.baseFormGroup.setValidators(
      [
        this.angazovanjeRoValidators.valRadnoVremePrcAng(this)
        , this.angazovanjeRoValidators.valCenaRada(this)
      ]
    );

    // this.baseFormGroup.setValidators(
    //   cenaRada(this)
    // );

    this.IDProcessed.subscribe(value => {
      this.RaskidDostupan = true;
      this.AnexDostupan =
        this.baseFormGroup.get("ImaAnex").value ||
        !this.baseFormGroup.get("ImaRaskid").value;
      if (this.baseFormGroup.get("ID").value != null) {
        this.editMode = true;
      }

      if (!this.editMode) {
        this.AnexDostupan = false;
        this.RaskidDostupan = false;
      }
    });

    if (this.ParentProperty){  
      this.baseFormGroup.patchValue({OsobaID: this.ParentProperty.Value});
      this.baseFormGroup.get('OsobaID').disable();
    }

    // if (this.activatedRoute.component.toString().includes("function AppComponent")) {
    //   // pozvan iz menija
    //   this.baseFormGroup.get('OsobaID').enable();
    // } else {
    //   // pozvan sa forme zaposlenih
    //   this.baseFormGroup.get('OsobaID').disable();
    // }
  }

  onPodvrstaDokumentaStavkaSelected(item) {
    if (item != null) {
      // this.RaskidUgovora=item["PodvrstaDokumentaGn"]=="resenje";
      // this.Ugovor=item["PodvrstaDokumentaGn"]=="ug";
      // this.AneksUgovora=item["PodvrstaDokumentaGn"]=="anex_ug";
      this.getBrojDokumenta();
    }
  }

  onStatusROSelected(item) {
    if (item != null) {
      this.baseFormGroup.get("OdDatuma").enable();
      this.baseFormGroup.get("OdDatuma").updateValueAndValidity();
      if (item.Privremen!=null && item.Privremen){
        this.baseFormGroup.get("DoDatuma").enable();
      } else {
        this.baseFormGroup.patchValue({DoDatuma: null});
        this.baseFormGroup.get("DoDatuma").disable();
      }
      this.baseFormGroup.get("DoDatuma").updateValueAndValidity();
    }
  }

  onRadnoVremeSelected(item){
    if (item != null){
      if (item.genericname=='PUNO'){
        if (this.baseFormGroup.get("PrcAng").value==null){
          this.baseFormGroup.patchValue({PrcAng: 100});
          this.baseFormGroup.get("PrcAng").updateValueAndValidity();
        };
      };
    }
  }

  onPrcAngChange(value){
    let prcAng=this.baseFormGroup.get("PrcAng").value;
    if (value != null && prcAng != null && prcAng>0)
      this.baseFormGroup.patchValue({
        NedFondSati: kadblDajPodrazumevaniNedeljniFondSatiZaPrcAng(prcAng)
      });

    this.baseFormGroup.patchValue({
      NedFondSati: kadblDajPodrazumevaniNedeljniFondSatiZaPrcAng(0)
    });

    this.baseFormGroup.get("NedFondSati").updateValueAndValidity();
  }

  onDatumChange(value) {
    if (value != null) {
      this.getBrojDokumenta();
    }
  }

  // getBrojDokumenta() {
  //   let podvrstaid = this.baseFormGroup.get("PodvrstaDokumentaStavkaID").value;
  //   let datum = this.baseFormGroup.get("Datum").value;
  //   if (this.Item.ID == -1 && podvrstaid && datum)
  //     this.baseDataService
  //       .GetData("AngazovanjeRo", "KreirajBrojDokumenta", {
  //         PodVrstaDokumentaStavkaID: podvrstaid,
  //         Datum: datum
  //       })
  //       .subscribe(data => {
  //         this.baseFormGroup.patchValue({ Broj: data });
  //         this.baseFormGroup.get("Broj").updateValueAndValidity();
  //       });
  // }

  getBrojDokumenta() {
    let podvrstaid = this.baseFormGroup.get("PodvrstaDokumentaStavkaID").value;
    let datum = this.baseFormGroup.get("Datum").value;
    if (this.Item.ID == -1 && podvrstaid && datum) {
      kadblDajBrojZaNoviDokument(this.baseDataService, podvrstaid, datum)
      .subscribe((data)=>{
          this.baseFormGroup.patchValue({ Broj: data });
          this.baseFormGroup.get("Broj").updateValueAndValidity();
      });
    }
  }

  anexNew() {
    let _modelData = this.modelDataService.GetModelDataByPath(
      "angazovanjeroanex"
    );
    
    let qpAnexOsobaID = new QueryParameter("OsobaID", this.Item.OsobaID);
    let qpAnexUgovorID = new QueryParameter("TataID", this.Item.ID);
    
    this.modalService
    .ShowModal(-1, _modelData, null, true, [qpAnexOsobaID, qpAnexUgovorID])
    .result.then(
      item => {
        //this.EmitItem(item);
        //OK
      },
      reason => {
        //!OK
      }
    );
  }

  anexEdit() {
    let _modelData = this.modelDataService.GetModelDataByPath(
      "angazovanjeroanex"
    );

    let qpAnexOsobaID = new QueryParameter("OsobaID", this.Item.OsobaID);
    let qpAnexUgovorID = new QueryParameter("TataID", this.Item.ID);

    if (this.Item.ImaAnex) {
      this.baseDataService
        .Get(
          "AngazovanjeRo"
          , "GetByTataID"
          , [qpAnexUgovorID]
          , AngazovanjeRoResenje
        )
        .subscribe(data => {
          this.modalService
            .ShowModal(data[0]["ID"], _modelData, null, true, [
              qpAnexOsobaID,
              qpAnexUgovorID
            ])
            .result.then(
              item => {
                //OK
              },
              reason => {
                //!OK
              }
            );
        });
    } else {
      // this.modalService
      //   .ShowModal(-1, _modelData, null, true, [qpAnexOsobaID, qpAnexUgovorID])
      //   .result.then(
      //     item => {
      //       //this.EmitItem(item);
      //       //OK
      //     },
      //     reason => {
      //       //!OK
      //     }
      //   );
    }
  }

  raskidEdit() {
    let _modelData = this.modelDataService.GetModelDataByPath(
      "angazovanjeroresenje"
    );

    let qpRaskidOsobaID = new QueryParameter("OsobaID", this.Item.OsobaID);
    let qpRaskidUgovorID = new QueryParameter("TataID", this.Item.ID);

    if (this.Item.ImaRaskid) {
      // Ovo ovde treba da pokupi id raskida i kada pokupi da pozove modalni, Marija da napravi SP
      this.baseDataService
        .Get(
          "AngazovanjeRoResenje",
          "GetByTataID",
          [qpRaskidUgovorID],
          AngazovanjeRoResenje
        )
        .subscribe(data => {
          this.modalService
            .ShowModal(data[0]["ID"], _modelData, null, true, [
              qpRaskidOsobaID,
              qpRaskidUgovorID
            ])
            .result.then(
              item => {
                //OK
              },
              reason => {
                //!OK
              }
            );
        });
    } else {
      this.modalService
        .ShowModal(-1, _modelData, null, true, [
          qpRaskidOsobaID,
          qpRaskidUgovorID
        ])
        .result.then(
          item => {
            //this.EmitItem(item);
            //OK
          },
          reason => {
            //!OK
          }
        );
    }
  }
  
  unosPoslova(){
    // Preraditi ovo dole za poslove, kreirati modele na serverskoj i klijentskoj strani pretoga
    let _modelData = this.modelDataService.GetModelDataByPath(
      "angazovanjeroresenje"
    );

    let qpRaskidOsobaID = new QueryParameter("OsobaID", this.Item.OsobaID);
    let qpRaskidUgovorID = new QueryParameter("TataID", this.Item.ID);

    if (this.Item.ImaRaskid) {
      // Ovo ovde treba da pokupi id raskida i kada pokupi da pozove modalni, Marija da napravi SP
      this.baseDataService
        .Get(
          "AngazovanjeRoResenje",
          "GetByTataID",
          [qpRaskidUgovorID],
          AngazovanjeRoResenje
        )
        .subscribe(data => {
          this.modalService
            .ShowModal(data[0]["ID"], _modelData, null, true, [
              qpRaskidOsobaID,
              qpRaskidUgovorID
            ])
            .result.then(
              item => {
                //OK
              },
              reason => {
                //!OK
              }
            );
        });
    } else {
      this.modalService
        .ShowModal(-1, _modelData, null, true, [
          qpRaskidOsobaID,
          qpRaskidUgovorID
        ])
        .result.then(
          item => {
            //this.EmitItem(item);
            //OK
          },
          reason => {
            //!OK
          }
        );
    }
  }

  RadnoVremeGetItems(items)
  {
    this.radnoVremeItems=items;
  };

  StatusRoGetItems(items)
  {
    this.statusRoItems=items;
  }

}
